import React from 'react'
import kapish from "../../Assets/images/Kapish.png"
import amritanshu from "../../Assets/images/amritanshu-kumar.png"
const Team = () => {
  return (
    <>
    <section className='section-top-padding section-bottom-padding'>
        <div className='container'>
            <h2 className='heading-title mb-4 mb-lg-5 px-4 px-lg-0'>
            Meet the Team Behind MasterNaukri
            </h2>
            <div className="logo-slider row  px-4 px-lg-0">
                <div className='col-lg-5 offset-lg-1 mb-4 mb-lg-0'>
                  <div className='shadow-box team-user'>
                      <img src={kapish} alt='' />
                      <div>
                        <h3>Kapish Saraf</h3>
                        <h6>Founder & Director</h6>
                        <p>IIT Kharagpur, IIM Calcutta</p>
                      </div>  
                  </div>
                </div>
                <div className='col-lg-5'>
                  <div className='shadow-box team-user'>
                      <img src={amritanshu} alt='' />
                      <div>
                        <h3>Amritanshu Kumar</h3>
                        <h6>Co-Founder & CTO</h6>
                        <p>IIT Kharagpur, IIM Calcutta</p>
                      </div>  
                  </div>
                </div>
            </div>
        </div>
      </section>
    </>
  )
}

export default Team